import React from 'react';
import { Link } from 'react-router-dom';
import classes from './Header.module.css';
import LotusLogo from './LotusLogo';
import LanguageSwitcher from './LanguageSwitcher';
import { useI18n } from '../i18n/LanguageContext';

function Header() {
  const { t, path } = useI18n();

  return (
    <header className={classes.header}>
      <div className={classes.inner}>
        <Link to={path('/')} className={classes.brand} aria-label={t('nav.brandAria')}>
          <span className={classes.brandLogo}>
            <LotusLogo />
          </span>
          <span className={classes.brandName}>Manifestify</span>
        </Link>
        <nav className={classes.nav} aria-label={t('nav.mainAria')}>
          <Link to={path('/blog')} className={classes.navLink}>
            {t('nav.blog')}
          </Link>
          <LanguageSwitcher />
        </nav>
      </div>
    </header>
  );
}

export default Header;
